export default __webpack_public_path__ + "static/media/nip_5.30fd63d5.jpg";